import React from "react";

type Props = {
  children: React.ReactNode;
  onReset?: () => void;
  onApply?: () => void;
  hasActive?: boolean;
  applyDisabled?: boolean;
  applyLabel?: string;
  className?: string;
  sticky?: boolean;
  noWrap?: boolean;
  stackButtons?: boolean;
};

export default function FilterBar({
  children,
  onReset,
  onApply,
  hasActive,
  applyDisabled,
  applyLabel = "Применить",
  className = "",
  sticky = true,
  noWrap = false,
  stackButtons = false,
}: Props) {
  return (
    <div
      className={[
        sticky ? "sticky top-[72px] z-20" : "",
        "bg-slate-50/70 backdrop-blur supports-[backdrop-filter]:bg-slate-50/70",
        "border border-slate-100 rounded-3xl",
        "px-4 py-4 md:px-6 md:py-5",
        className,
      ].join(" ")}
    >
      <div className="flex flex-wrap items-center gap-3">
        {/* Поля фильтров (растягиваем) */}
        <div
          className={[
            "flex flex-1 gap-3",
            noWrap ? "flex-nowrap items-center overflow-x-auto" : "flex-wrap",
          ].join(" ")}
        >
          {children}
        </div>

        {/* Кнопки (тоже растягиваем адаптивно) */}
        <div
          className={[
            "flex gap-2",
            stackButtons
              ? "flex-col w-full items-end"
              : noWrap
                ? "items-center w-auto"
                : "flex-wrap w-full md:w-auto",
          ].join(" ")}
        >
          {onApply && (
            <button
              type="button"
              onClick={onApply}
              disabled={applyDisabled}
              className={[
                "px-5 py-2 rounded-2xl border border-indigo-200 bg-white text-indigo-600 shadow-[0_10px_22px_rgba(99,102,241,0.15)] transition hover:bg-indigo-50 hover:text-indigo-700 disabled:opacity-50",
                stackButtons ? "w-full md:w-auto" : noWrap ? "whitespace-nowrap" : "w-full md:w-auto flex-1",
              ].join(" ")}
            >
              {applyLabel}
            </button>
          )}
          {onReset && (
            <button
              type="button"
              onClick={onReset}
              disabled={!hasActive}
              className={[
                "px-5 py-2 rounded-2xl border bg-white hover:bg-slate-50 disabled:opacity-50",
                stackButtons ? "w-full md:w-auto" : noWrap ? "whitespace-nowrap" : "w-full md:w-auto flex-1",
              ].join(" ")}
            >
              Сбросить
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
